/**
 * File: AslTfController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class AslTfController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, $timeout,CONSTANTS,CQuesConst,uploadService) {
      var MQ = MathQuill.getInterface(2);
      let UPLOAD_URL = CONSTANTS.SERVER_UPLOAD
      let userId = localStorageService.get("user_id")
      let USER_PATH = userId + "/asl/"
      let schoolId = localStorageService.get("school_id")
      let ASL_ANS_TYPE=CQuesConst.ASL_ANS_TYPE
      let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
      let QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT
      let GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES
      let GET_PASSAGE = CQuesConst.API_GET_PASSAGE
      $scope.tf = {}
      $scope.tf.credentials = {
      question: '',
      answer: '',
      explanation: '',
      falseHint: '',
      isLatex: false
    }

    $scope.errors = {};

    $scope.index;
      //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Archives"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            $scope.index = this.index
            $scope.id = 'tf-math-field' + $scope.index;
            if ($scope.$parent.editQuestions[$scope.index]) {
              let question = $scope.$parent.editQuestions[$scope.index]
              if (question && question.choice) {
                $scope.tf.credentials.question = question.qn_desc;
                $scope.tf.credentials.questionImg = question.questionImg;
                $scope.tf.credentials.isLatex = question.isLatex;
                $scope.tf.credentials.answer = _.find(question.choice, function(ch) {
                  return ch.correct
                }).tag;
                let explanation=_.find(question.choice, function(ch) {
                  return ch.correct
                });
                $scope.tf.credentials.explanation = explanation.explanation;
                $scope.tf.explanationImage=explanation.explanationImage;
                let hint=_.find(question.choice, function(ch) {
                  return !ch.correct
                })
                $scope.tf.credentials.falseHint = hint.hint;
                $scope.tf.falseHintImage=hint.falseHintImage;
              }
            }
        }
        //On destroy function
        this.$onDestroy = () => {
        }

          //Question desc with latex
          $timeout(() => {
            var mathFieldSpan = document.getElementById('tf-math-field' + $scope.index);
            mathFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
            var MQ = MathQuill.getInterface(2);
            if ($scope.tf.credentials.question) {
              mathFieldSpan.textContent = $scope.tf.credentials.question
            }
            var mathField = MQ.MathField(mathFieldSpan, {
              spaceBehavesLikeTab: false,
              restrictMismatchedBrackets: true,
              handlers: {
                edit: function() {
                  $scope.tf.credentials.question = mathField.latex()
                }
              }
            });
          }, 1000)
      
          //Image upload for question
          $scope.tf.uploadImg = function(file, opt) {
            let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
            _.each(file, function (fileObj) {
                let extValue = fileObj.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                  uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                  if (result.url) {
                    opt.questionImg = result.url
                  }
                })
              } else {
                toastr.error("Please select the supported format jpg, jpeg, png")
                fileObj = {}
              }
            })
          }
      
          $scope.tf.removeQuestionImg = function() {
            $scope.tf.credentials.questionImg = undefined;
          }
      
          $scope.paste = function(e){
            e.preventDefault();
            return false
          }
      
          //Image upload for explanation
          $scope.tf.explanationImgUpload = function(file, opt) {
            let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
            _.each(file, function (fileObj) {
                let extValue = fileObj.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                  uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                  if (result.url) {
                    opt.explanationImage = result.url
                  }
                })
              } else {
                toastr.error("Please select the supported format jpg, jpeg, png")
                fileObj = {}
              }
            })
          }
      
          $scope.tf.removeExplanationImage = function() {
            $scope.tf.explanationImage = undefined;
          }
      
          //Image upload for falsehint
          $scope.tf.falseHintImgUpload = function(file, opt) {
            _.each(file, function (fileObj) {
              let extValue = fileObj.name.split('.').pop().toLowerCase();
              if (_.contains(supportedFrmts, extValue)) {
                  uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                  if (result.url) {
                    opt.falseHintImage = result.url
                  }
                })
              } else {
                toastr.error("Please select the supported format jpg, jpeg, png")
                fileObj = {}
              }
            })
          }
      
          $scope.tf.removeFalseHintImage = function() {
            $scope.tf.falseHintImage = undefined;
          }
      
          /*
           * Function to add to list
           *
           * @return : null
           */
          $scope.addToList = () => {
            $scope.errors = {}
            let errCount = 0;
            //[Object] - to push correct and wrong answer object
            let choice = []
      
            //Object - correct answer
            let correctObj = {};
      
            //Object - wrong answer
            let wrongObj = {};
      
            if ($scope.tf.credentials.answer === "True") {
              correctObj.tag = "True"
              wrongObj.tag = "False"
            } else {
              correctObj.tag = "False"
              wrongObj.tag = "True"
            }
            correctObj.explanation = $scope.tf.credentials.explanation;
            correctObj.correct = true;
            correctObj.explanationImage=$scope.tf.explanationImage;
            choice.push(correctObj);
            wrongObj.hint = $scope.tf.credentials.falseHint;
            wrongObj.correct = false;
            wrongObj.falseHintImage=$scope.tf.falseHintImage;
            choice.push(wrongObj);
      
            //Validation  
            if ($scope.tf.credentials.question == null || $scope.tf.credentials.question == undefined || $scope.tf.credentials.question == "") {
              $scope.errors.question = "Question is required";
              $scope.errCount++;
            } else if ($scope.tf.credentials.question.length > 500) {
              $scope.errors.question = "Question does not exceed 500 characters";
              errCount++;
            }
            if ($scope.isPractice) {
              if ($scope.tf.credentials.explanation == null || $scope.tf.credentials.explanation == undefined || $scope.tf.credentials.explanation == "") {
                $scope.errors["explanation"] = "Explanation is required"
                $scope.errCount++;
              }
              if ($scope.tf.credentials.falseHint == null || $scope.tf.credentials.falseHint == undefined || $scope.tf.credentials.falseHint == "") {
                $scope.errors["falseHint"] = "False hint is required"
                $scope.errCount++;
              }
            }
            if ($scope.tf.credentials.explanation && $scope.tf.credentials.explanation.length > 500) {
              $scope.errors["explanation"] = "Explanation does not exceed 500 characters";
              errCount++;
            }
            if ($scope.tf.credentials.falseHint && $scope.tf.credentials.falseHint.length > 500) {
              $scope.errors["falseHint"] = "False does not exceed 500 characters";
              errCount++;
            }
            if ($scope.tf.credentials.answer == null || $scope.tf.credentials.answer == undefined || $scope.tf.credentials.answer == "") {
              $scope.errors["answer"] = "Answer is required"
              $scope.errCount++;
            } else if ($scope.tf.credentials.answer.length > 500) {
              $scope.errors["answer"] = "Answer does not exceed 500 characters";
              errCount++;
            }
            if (errCount == 0) {
              let obj = {
                type: ASL_ANS_TYPE.TF,
                qn_desc: $scope.tf.credentials.question,
                isLatex: $scope.tf.credentials.isLatex,
                choice: choice,
                questionImg:$scope.tf.credentials.questionImg
              }
      
              $scope.tf.credentials.question = ''
              $scope.tf.credentials.answer = ''
              $scope.tf.credentials.explanation = ''
              $scope.tf.credentials.falseHint = ''
              $scope.tf.credentials.isLatex = false
              $scope.$parent.addToList(obj, $scope.index)
            }
          }
      

    }
}

export default AslTfController;


// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/aslTfController.js